import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Layout from '../../templates/Layout';
import ReportTable from '../../organisms/table/ReportTable';
import { Helmet } from 'react-helmet';
import Notice from '../../molecules/Notice';
const Overview = ({ reports, notice }) => {
    return (_jsxs(Layout, { "data-testid": "report-overview", children: [_jsx(Helmet, { children: _jsx("title", { children: "Beheer periodieke rapportages" }) }), _jsx(H1, { "data-testid": "title", children: "Beheer periodieke rapportages" }), notice && (_jsx(Notice, { type: notice.type, text: notice.text, title: notice.title })), _jsx(Row, { children: _jsx(Col, { sm: 12, children: _jsx(ReportTable, { reports: reports.data }) }) })] }));
};
export default Overview;
